import { render, staticRenderFns } from "./EditVideoDialog.vue?vue&type=template&id=43a46003"
import script from "./EditVideoDialog.vue?vue&type=script&lang=js"
export * from "./EditVideoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports